import React from 'react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { adminTabs, childTabs } from '../../data/navigation';
export function BottomNav() {
  const {
    isAdmin,
    approvalsCount
  } = useAppState();
  const {
    tab,
    setTab,
    sub
  } = useUi();
  const tabs = isAdmin ? adminTabs : childTabs;
  return <nav aria-label="Glavna navigacija" className="border-t border-line bg-surface pb-[env(safe-area-inset-bottom)]" data-id="element-886" data-mp="2jinnwgshqdaq">
      <ul className="grid grid-cols-4" data-id="element-887" data-mp="1qw2r30t8x8zs">
        {tabs.map(({
        id,
        label,
        icon: Icon
      }) => {
        const active = !sub && tab === id;
        return <li key={id} data-id="element-888" data-mp="1vturkj7yi3fl">
              <button type="button" onClick={() => setTab(id)} aria-current={active ? 'page' : undefined} className={`relative flex h-16 w-full flex-col items-center justify-center gap-1 text-xs font-bold transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-accent ${active ? 'text-accent-ink' : 'text-muted'}`} data-id="element-889" data-mp="1vtcph5ym4uzr">
                <span className={`grid h-8 w-12 place-items-center rounded-full transition-colors duration-150 ${active ? 'bg-accent-soft' : ''}`} data-id="element-890" data-mp="scolbfkv7lm9">
                  <Icon className="h-5 w-5" aria-hidden="true" strokeWidth={active ? 2.5 : 2} data-id="element-891" data-mp="oabhwxtlbzsn" />
                </span>
                {label}
                {id === 'pregled' && approvalsCount > 0 && <span className="absolute right-[calc(50%-24px)] top-1.5 min-w-[18px] rounded-full bg-accent px-1 text-[10px] font-extrabold leading-[18px] text-white" data-id="element-892" data-mp="ebc6j7hfxq1y">
                    {approvalsCount}
                  </span>}
              </button>
            </li>;
      })}
      </ul>
    </nav>;
}